// Copyright 2022 - 2023 Fewcha. All rights reserved.

import Joi from "joi";

export type ThemeType = "light" | "dark";

export const validThemes = ["light", "dark"];

export type ThemeReducer = {
  theme: ThemeType;
  showBalance: boolean;
  coinsShowList: boolean;

  loading: boolean;
  version: string;
};

export const defaultThemeReducer: ThemeReducer = {
  theme: "light",
  showBalance: true,
  coinsShowList: true,

  loading: false,
  version: "0.1.0",
};

const schema = Joi.object<ThemeReducer>({
  theme: Joi.string().valid("light", "dark").default("light").required(),
  showBalance: Joi.boolean().default(true).required(),
  coinsShowList: Joi.boolean().default(true).required(),

  loading: Joi.boolean().default(false).required(),
  version: Joi.string().default("0.1.0").required(),
});

export const themeValidate = (data: ThemeReducer) => schema.validate(data);
